// Live widget preview for the Install & Deploy page (Slice 6c). It renders a
// faithful mock of the deployed panel — same shared renderer registry the real
// widget and the operator Timeline use (@retink/connector-webchat/renderers) —
// skinned by the appearance under edit. Pure client, no server round-trip, so
// it updates as the admin types. The `.wc-preview` skin lives in styles.css and
// reads the appearance via CSS vars (--rc-accent) + data-rc-theme, exactly like
// the real widget's shadow root.
import { renderPart } from '@retink/connector-webchat/renderers'
import type { WebchatAppearance } from '@retink/connector-webchat/appearance'
import type { CSSProperties } from 'react'

const NO_OP = () => {}

// A representative sample transcript — shows text, a choice and a rich card so
// the accent + theme are visible across the vocabulary.
const SAMPLES: Array<{ type: string; [k: string]: unknown }> = [
  { type: 'choice', text: 'What can we help you with?', options: [
    { label: 'Book a table', value: 'book' },
    { label: 'Opening hours', value: 'hours' },
  ] },
  { type: 'card', title: 'Table for 2', subtitle: 'Tonight · 7:00 PM', body: 'Window seat, quiet corner.', actions: [
    { label: 'Confirm', value: 'confirm' },
  ] },
]

export function WidgetPreview({ appearance }: { appearance: WebchatAppearance }) {
  const style = { '--rc-accent': appearance.primaryColor } as CSSProperties
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="wc-preview" data-rc-theme={appearance.theme} style={style}>
        <div className="wc-panel">
          <div className="wc-head">{appearance.headerTitle || 'Chat'}</div>
          <div className="wc-msgs">
            {appearance.greeting ? <div className="rc-bubble assistant">{appearance.greeting}</div> : null}
            {SAMPLES.map((part, i) => (
              <div key={i} className="wc-row">{renderPart(part, NO_OP)}</div>
            ))}
          </div>
          <div className="wc-compose">
            <input placeholder="Type a message…" disabled />
            <button type="button" disabled>Send</button>
          </div>
        </div>
      </div>
      <div className="text-xs text-muted-foreground">
        Launcher: {appearance.position === 'bottom-left' ? 'bottom-left' : 'bottom-right'} · Theme: {appearance.theme}
      </div>
    </div>
  )
}
